const STORAGE_KEY_PREFIX = "extract_data_";
const STORAGE_EXPIRY_DAYS = 7;

export interface LocalStorageData {
    extractedJson: any;
    selectedFormType: string;
    currentPageIndex: number;
    viewedPages: Record<string, number[]>; // Serialize Sets as arrays
    timestamp: number;
}

const getLocalStorageKey = (key: string): string => `${STORAGE_KEY_PREFIX}${key}`;

export const saveToLocalStorage = (key: string, data: LocalStorageData): void => {
    try {
        localStorage.setItem(getLocalStorageKey(key), JSON.stringify(data));
    } catch (error) {
        console.error("Failed to save to localStorage:", error);
    }
};

export const loadFromLocalStorage = (key: string): LocalStorageData | null => {
    try {
        const stored = localStorage.getItem(getLocalStorageKey(key));
        if (!stored) return null;

        const data: LocalStorageData = JSON.parse(stored);
        const now = Date.now();
        const ageInDays = (now - data.timestamp) / (1000 * 60 * 60 * 24);

        // Warn if data is older than expiry period
        if (ageInDays > STORAGE_EXPIRY_DAYS) {
            console.warn(`localStorage data is ${ageInDays.toFixed(1)} days old, ignoring`);
            clearLocalStorage(key);
            return null;
        }

        return data;
    } catch (error) {
        console.error("Failed to load from localStorage:", error);
        return null;
    }
};

export const clearLocalStorage = (key: string): void => {
    try {
        localStorage.removeItem(getLocalStorageKey(key));
    } catch (error) {
        console.error("Failed to clear localStorage:", error);
    }
};
